import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { AccommodationType } from '../accommodation-type';
import { BoardType } from '../board-type';
import { HttpService } from '../service/http.service';
import { RoomType } from '../room-type';
import { BookingService } from './booking.service';

@Injectable({
  providedIn: 'root'
})
export class BookingAccommodationService {

  accommodationTypes: AccommodationType[] = [];
  roomTypes: RoomType[] = [];
  boardTypes: BoardType[] = [];

  accommodationForm!: FormGroup;
  canEditAccommodationDate = true;

  constructor(
    private bookingService: BookingService,
    private builder: FormBuilder,
    private httpService: HttpService
  ) { }

  updateAccommodation() {
    if (this.bookingService.booking.accommodation) {
      this.bookingService.booking.accommodation.accommodationType = this.accommodationForm.value.accommodationType;
      this.bookingService.booking.accommodation.roomType = this.accommodationForm.value.roomType;
      this.bookingService.booking.accommodation.boardType = this.accommodationForm.value.boardType;
      this.bookingService.booking.accommodation.name = this.accommodationForm.value.name;
      this.bookingService.booking.accommodation.address = this.accommodationForm.value.address;
      this.bookingService.booking.accommodation.city = this.accommodationForm.value.city;
      this.bookingService.booking.accommodation.phoneNumber = this.accommodationForm.value.phoneNumber;
      this.bookingService.booking.accommodation.email = this.accommodationForm.value.email;
      this.bookingService.booking.accommodation.contactLanguage = this.accommodationForm.value.accommodationLanguage;
      this.bookingService.booking.accommodation.hostFirstName = this.accommodationForm.value.hostFirstName;
      this.bookingService.booking.accommodation.hostLastName = this.accommodationForm.value.hostLastName;
      this.bookingService.booking.accommodation.postCode = this.accommodationForm.value.accommodationPostCode;
      this.bookingService.booking.accommodation.country = this.accommodationForm.value.hostCountry;
      this.bookingService.booking.accommodation.startDate = moment(this.accommodationForm.value.accommodationStartDate).utc(true);
      this.bookingService.booking.accommodation.endDate = moment(this.accommodationForm.value.accommodationEndDate).utc(true);
      this.bookingService.booking.accommodation.travelTimeToSchool = this.accommodationForm.value.travelTimeToSchool;
      this.bookingService.booking.accommodation.otherInternationalStudent = this.accommodationForm.value.otherInternationalStudent;
      this.bookingService.booking.accommodation.comment = this.accommodationForm.value.accommodationComment;
      this.bookingService.booking.accommodation.name = this.accommodationForm.value.accommodationName;
    } else {
      throw new Error("this booking has no accommodation!");
    }
  }

  initAccommodationForm(){
    this.accommodationForm = this.builder.group({
      accommodationType: this.bookingService.booking.accommodation.accommodationType,
      roomType: this.bookingService.booking.accommodation.roomType,
      boardType: this.bookingService.booking.accommodation.boardType,
      name: this.bookingService.booking.accommodation.name,
      address: this.bookingService.booking.accommodation.address,
      city: this.bookingService.booking.accommodation.city,
      phoneNumber: this.bookingService.booking.accommodation.phoneNumber,
      email: this.bookingService.booking.accommodation.email,
      travelTimeToSchool: this.bookingService.booking.accommodation.travelTimeToSchool,
      otherInternationalStudent: this.bookingService.booking.accommodation.otherInternationalStudent,
      accommodationStartDate: moment(this.bookingService.booking.accommodation.startDate).toDate(),
      accommodationEndDate: moment(this.bookingService.booking.accommodation.endDate).toDate(),
      hostCountry: this.bookingService.booking.accommodation.country,
      accommodationLanguage: this.bookingService.booking.accommodation.contactLanguage,
      hostFirstName: this.bookingService.booking.accommodation.hostFirstName,
      hostLastName: this.bookingService.booking.accommodation.hostLastName,
      accommodationPostCode: this.bookingService.booking.accommodation.postCode,
      accommodationComment: this.bookingService.booking.accommodation.comment,
      internalComment: null,
      accommodationName: this.bookingService.booking.accommodation.name,
      canEditAccommodationDate: false
    });
  }

  updateAccommodationForm(){
    this.accommodationForm.get("accommodationType")!.setValue(this.bookingService.booking.accommodation.accommodationType);
    this.accommodationForm.get("roomType")!.setValue(this.bookingService.booking.accommodation.roomType);
    this.accommodationForm.get("boardType")!.setValue(this.bookingService.booking.accommodation.boardType);
    this.accommodationForm.get("name")!.setValue(this.bookingService.booking.accommodation.name);
    this.accommodationForm.get("address")!.setValue(this.bookingService.booking.accommodation.address);
    this.accommodationForm.get("city")!.setValue(this.bookingService.booking.accommodation.city);
    this.accommodationForm.get("phoneNumber")!.setValue(this.bookingService.booking.accommodation.phoneNumber);
    this.accommodationForm.get("email")!.setValue(this.bookingService.booking.accommodation.email);
  }
}
